/**
 * CheepSweepz destination catalog — synced with DHC lib/cheep/caribbean-destinations.ts
 * ISO-3166 codes only (carriers do not accept "OECS").
 */

export const CHEEP_DESTINATIONS = [
  { code: "BB", name: "Barbados", region: "caribbean", currency: "USD", flag: "🇧🇧", hubClearance: true,
    customs: { type: "tamis", required: true, label: "TAMIS ID", hint: "13-digit Barbados Revenue Authority TAMIS number." } },
  { code: "TT", name: "Trinidad & Tobago", region: "caribbean", currency: "USD", flag: "🇹🇹", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "BIR / Customs ID", hint: "Your Trinidad & Tobago importer or BIR reference." } },
  { code: "JM", name: "Jamaica", region: "caribbean", currency: "USD", flag: "🇯🇲", hubClearance: false,
    customs: { type: "trn", required: true, label: "TRN", hint: "9-digit Jamaica Tax Registration Number." } },
  { code: "AG", name: "Antigua & Barbuda", region: "caribbean", currency: "USD", flag: "🇦🇬", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "National customs or tax importer reference." } },
  { code: "BS", name: "Bahamas", region: "caribbean", currency: "USD", flag: "🇧🇸", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "Bahamas customs importer reference." } },
  { code: "BZ", name: "Belize", region: "caribbean", currency: "USD", flag: "🇧🇿", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "Belize customs or TIN reference." } },
  { code: "DM", name: "Dominica", region: "caribbean", currency: "USD", flag: "🇩🇲", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "Dominica customs importer reference." } },
  { code: "GD", name: "Grenada", region: "caribbean", currency: "USD", flag: "🇬🇩", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "Grenada customs importer reference." } },
  { code: "GY", name: "Guyana", region: "caribbean", currency: "USD", flag: "🇬🇾", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "Guyana TIN or customs reference." } },
  { code: "HT", name: "Haiti", region: "caribbean", currency: "USD", flag: "🇭🇹", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "Haiti customs clearance reference." } },
  { code: "KN", name: "St. Kitts & Nevis", region: "caribbean", currency: "USD", flag: "🇰🇳", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "National customs importer reference." } },
  { code: "LC", name: "St. Lucia", region: "caribbean", currency: "USD", flag: "🇱🇨", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "St. Lucia customs importer reference." } },
  { code: "VC", name: "St. Vincent & the Grenadines", region: "caribbean", currency: "USD", flag: "🇻🇨", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "SVG customs importer reference." } },
  { code: "SR", name: "Suriname", region: "caribbean", currency: "USD", flag: "🇸🇷", hubClearance: false,
    customs: { type: "customs_reference", required: true, label: "Importer / Customs ID", hint: "Suriname customs or tax reference." } },
  { code: "US", name: "United States", region: "international", currency: "USD", flag: "🇺🇸", hubClearance: false,
    customs: { type: "none", required: false, label: "", hint: "" } },
  { code: "CA", name: "Canada", region: "international", currency: "CAD", flag: "🇨🇦", hubClearance: false,
    customs: { type: "none", required: false, label: "", hint: "" } },
  { code: "UK", name: "United Kingdom", region: "international", currency: "GBP", flag: "🇬🇧", hubClearance: false,
    customs: { type: "none", required: false, label: "", hint: "" } },
];

const LEGACY_MAP = { OECS: "LC", GB: "UK" };

export function resolveDestinationCode(code) {
  const upper = (code || "BB").trim().toUpperCase();
  return LEGACY_MAP[upper] || upper;
}

export function getDestinationConfig(code) {
  const resolved = resolveDestinationCode(code);
  return CHEEP_DESTINATIONS.find((d) => d.code === resolved);
}

export function listShopDestinations() {
  return CHEEP_DESTINATIONS;
}

export function listCaribbeanOnly() {
  return CHEEP_DESTINATIONS.filter((d) => d.region === "caribbean");
}
